import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <div className={styles.footer}>
      <div className={styles.footerMainContent}>
        <div className={styles.footerLeft}>
          <div className={styles.imageContainer}>
            <img src={`${process.env.PUBLIC_URL}/assets/footer-ctia-logo.svg`} alt="ctia" />
            <img src={`${process.env.PUBLIC_URL}/assets/footer-gch-logo.svg`} alt="gch" />
          </div>
          <div>
            <p>The Short Code Registry is a service mark of CTIA.</p>
            <p>GCH Technologies® is a Trademark of GCH Technologies, Inc.</p>
          </div>
        </div>
        <div className={styles.footerCenter}>
          <p>© 2025 CTIA. All Rights Reserved.</p>
        </div>
      </div>
      <div className={styles.footerRight}>
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Scroll to top"
          className={styles.scrollToTopButton}
        >
          <img src={`${process.env.PUBLIC_URL}/assets/go-to-top.svg`} alt="go to top" />
        </button>
      </div>
    </div>
  );
};

export default Footer;

